import { render, staticRenderFns } from "./ForwardMessage.vue?vue&type=template&id=59dfa8db&scoped=true"
import script from "./ForwardMessage.vue?vue&type=script&lang=js"
export * from "./ForwardMessage.vue?vue&type=script&lang=js"
import style0 from "./ForwardMessage.vue?vue&type=style&index=0&id=59dfa8db&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59dfa8db",
  null
  
)

export default component.exports